import { createAction } from "../../utils/redux/createAction";
import { UPDATE_ATTRIBUTION_DATA } from "./types";
import { IAttributionState, IAction } from "../../ts/redux";

export function updateAttriutionData(payload: IAttributionState): IAction {
    return createAction(UPDATE_ATTRIBUTION_DATA, payload);
}